import React from 'react';
import { WithDefaultLayout } from '../components/DefautLayout';
import { Title } from '../components/Title';
import Link from 'next/link';
import { Page } from '../types/Page';
import { ChecklistProgram } from '@/components/program/ChecklistProgram';
import { LmsFaqSection } from '@/components/lms/LmsFaqSection';
import { NewSkillBox } from '@/components/program/NewSkillBox';
import { HeaderSection } from '@/components/common/headers/HeaderSection';
import ContactUsLms from '@/components/lms/LmsContactUs';
import AllPackageLms from '@/components/lms/LmsPackages';

const LmsIndexPage: Page = () => {
    return (
        <div>
            <Title title={'LMS'} description='' />
            <div>
                <section id='lms'>
                    <div className='flex flex-wrap justify-between items-center'>
                        <div className='m-24 self-center' style={{ width: 350 }}>
                            <h1 className='text-3xl md:text-4xl font-bold text-slate-900 mb-12 tracking-wider'>Anda Instansi atau Lembaga Sekolah? Belum Memiliki LMS?</h1>
                            <div className="bg-accent-100 rounded-md hover:bg-black duration-300 flex justify-center items-center mt-6 mb-2" style={{ width: 200, height: 50 }}>
                                <Link href={'#lms-package-type'} className="block duration-300 text-white hover:text-white text-lg md:text-xl text-accelist-font">
                                    Lihat Paket LMS
                                </Link>
                            </div>
                        </div>
                        <div className='relative m-0'>
                            <img src='/img/bg-mengapa-harus-memiliki-lms.png' alt='Workshop - Video Game.png' style={{ height: 'auto', width: '650px' }} />
                            <div className='absolute inset-0 bg-[#3B4687CC] opacity-0'></div>
                            <div className='absolute inset-0 flex flex-col items-center justify-center'>
                                <div className="bg-slate-800 rounded-xl p-4 md:p-6 items-center justify-center text-center max-w-screen-md mx-auto">
                                    <p className='text-lg md:text-xl font-bold text-white mb-4'>Mengapa Harus Memiliki Aplikasi LMS?</p>
                                    <div className='text-md flex flex-col flex-wrap text-white pb-2'>
                                        <ChecklistProgram name='Praktis, efisien, dan cepat' />
                                        <ChecklistProgram name='Penyimpanan data teratur' />
                                        <ChecklistProgram name='Mengurangi biaya operasional' />
                                        <ChecklistProgram name='Integrasi online secara otomatis' />
                                        <ChecklistProgram name='Materi yang bervariasi dan inovatif' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id='lms-price-info' className='bg-lms-solution'>
                    <div className="flex flex-col flex-wrap px-5 md:px-16">
                        <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center mt-16">
                            <p className="text-white text-base font-body font-semibold align-center mt-1 md:mt-3 sm:text-lg my-4">Kami Hadir sebagai LMS Solution<br></br>Penyedia Jasa Pembuatan LMS Lembaga, Perusahaan, dan Sekolah</p>
                        </div>
                    </div>
                </section>
                <div id='lms-package-type'>
                    <div className='flex flex-col mx-auto text-center mb-4 md:mb-8 items-center'>
                        <h2 className="text-slate-900 text-4xl font-body font-semibold align-center mt-20">Paket LMS Solution</h2>
                        <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mt-3 md:mt-5' />
                    </div>
                    <AllPackageLms />
                </div>
                <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center justify-center">
                    <p className="text-slate-900 text-2xl font-body font-semibold align-center mb-5">INFORMASI ISI PAKET LEBIH LANJUT?</p>
                    <ContactUsLms useCustomStyles={true} />
                </div>
            </div>
            <section id='lms-features'>
                <div className="flex flex-col flex-wrap px-2 pt-8 md:px-4 bg-[#f5f5f5]">
                    <div className="flex flex-col text-center md:mb-4 items-center gap-6">
                        <HeaderSection
                            title="Fitur LMS"
                            subtitle="Default non-custom"
                        />
                        <div className='align-middle flex flex-col items-center font-semibold text-md text-black'>
                            <div className='w-full max-w-xs md:max-w-none md:w-auto flex flex-wrap justify-center gap-2'>
                                <NewSkillBox name='Game' />
                                <NewSkillBox name='Absensi' />
                                <NewSkillBox name='Kalendar' />
                                <NewSkillBox name='Bank Soal' />
                                <NewSkillBox name='Perpusatakaan' />
                            </div>
                            <div className='w-full max-w-xs md:max-w-none md:w-auto flex flex-wrap justify-center gap-2'>
                                <NewSkillBox name='Pengunguman' />
                                <NewSkillBox name='Kuis atau ujian' />
                                <NewSkillBox name='Kategori Kurikulum' />
                            </div>
                            <div className='w-full max-w-xs md:max-w-none md:w-auto flex flex-wrap justify-center gap-2'>
                                <NewSkillBox name='Laporan perkembangan murid' />
                                <NewSkillBox name='Penilaian dan komentar hasil pekerjaan' />
                            </div>
                            <div className='w-full max-w-xs md:max-w-none md:w-auto'>
                                <NewSkillBox name='Isi Materi (Video, dokumen, teks, dan suara)' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id='lms-price-info' className='bg-lms-solution'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center mt-16">
                        <h2 className='text-white text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed'>Berapa Harganya?</h2>
                        <p className="text-white text-base font-body font-light align-center mt-1 md:mt-3 sm:text-lg mb-16">Mau tau harga dan informasi lebih lanjut? Klik WA admin ya</p>
                        <ContactUsLms useCustomStyles={false} />
                    </div>
                </div>
            </section>
            <LmsFaqSection />
        </div >
    );
}

LmsIndexPage.layout = WithDefaultLayout;
export default LmsIndexPage;